import type { ArInvoiceListRow } from '@dcc-erp/shared';

/** The /ar list tabs. Shared so saved views and the route agree on the union. */
export type ArTab = 'all' | 'open' | 'overdue' | 'duesoon' | 'paid';

// Due-soon worklist predicate: a POSTED invoice whose due date is in the future
// (not yet overdue) but lands within the next 7 days. Decoupled from the route
// so it can be unit-tested and reused for both the tab count and the row filter.
export function isDueSoon(r: Pick<ArInvoiceListRow, 'status' | 'dueDate'>, nowMs: number): boolean {
  if (r.status !== 'POSTED') return false;
  const due = new Date(r.dueDate).getTime();
  return due >= nowMs && due < nowMs + 7 * 864e5;
}
